import { Collapse, Tabs } from "@mantine/core";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import add from "../../assets/add.svg";
import "./styles.css";

const Item = ({ key, que, ans }) => {
  const [opened, setOpened] = useState(false);
  return (
    <div key={key} className="que">
      <p onClick={() => setOpened((o) => !o)} className="q">
        <img src={add} />
        {que}
      </p>
      <Collapse in={opened} className="px-4 ans">{ans}</Collapse>
    </div>
  );
};

export default withTranslation()(Item);
